var map = {
	"./1.svg": "4cvF",
	"./10.svg": "2iA6",
	"./2.svg": "UFI8",
	"./3.svg": "HDNM",
	"./4.svg": "NQQL",
	"./5.svg": "tejk",
	"./6.svg": "U+lS",
	"./7.svg": "e4wR",
	"./8.svg": "yzWU",
	"./9.svg": "hM9J",
	"./down.svg": "sA8s",
	"./up.svg": "x5CN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tL0p";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details/match_summary ^\.\/.*\.svg$
// module id = tL0p
// module chunks = 0